export default __webpack_public_path__ + "static/media/Scholar's Hood of Awakening.022222d9.jpg";